import { render, staticRenderFns } from "./CreateAccountAdditionalDetailsBtn.vue?vue&type=template&id=2f777f0f&"
import script from "./CreateAccountAdditionalDetailsBtn.vue?vue&type=script&lang=js&"
export * from "./CreateAccountAdditionalDetailsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports